import smiley from "../res/svg/smiley.svg";

function Main(){
    return(
        <div className="main margin el">
            <div className="spacearound">
                <h2 style={{width: "80vw"}}>Сервис вывоза и переработки пищевых отходов</h2>
                <img src = {smiley} alt = "smiley" style={{height: "3rem", width: "auto"}}></img>
            </div>
            <h1 style={{color: "#3EBC4B", fontSize: "7rem"}}>Öñde</h1>
            <h4 style={{width: "80vw"}}>Вносите свой вклад в экологию вместе с нами — теперь это также просто, как щелкнуть мышкой!</h4>
        </div>
    )
}

export default Main;